/**
 * Te Wiki o te Reo Māori — pool / swimming kupu for banners, session plans,
 * and the calendar Discover prompt. Tohutō required.
 */

export const TE_WIKI_SWIM_KUPU = [
  { word: 'kaukau', gloss: 'swim' },
  { word: 'kauhoe', gloss: 'swimming' },
  { word: 'puna kaukau', gloss: 'swimming pool' },
  { word: 'ruku', gloss: 'dive' },
  { word: 'kikī', gloss: 'kick' },
  { word: 'kume', gloss: 'pull' },
  { word: 'hopu', gloss: 'catch' },
  { word: 'raina', gloss: 'lane' },
  { word: 'pito', gloss: 'wall' },
  { word: 'tīmata', gloss: 'start' },
  { word: 'mutunga', gloss: 'finish' },
  { word: 'manawa', gloss: 'breath' },
  { word: 'tere', gloss: 'fast' },
  { word: 'wai', gloss: 'water' },
] as const;

/** Chips on the welcome banner — greetings plus swim kupu. */
export const TE_WIKI_BANNER_KUPU = [
  { word: 'kia ora', gloss: 'hello' },
  { word: 'kaukau', gloss: 'swim' },
  { word: 'ruku', gloss: 'dive' },
  { word: 'kikī', gloss: 'kick' },
  { word: 'kume', gloss: 'pull' },
  { word: 'raina', gloss: 'lane' },
  { word: 'tere', gloss: 'fast' },
  { word: 'ka rawe', gloss: 'excellent' },
] as const;

export function formatKupuWithGloss(
  rows: readonly { word: string; gloss: string }[],
): string {
  return rows.map((k) => `${k.word} (${k.gloss})`).join(', ');
}

/** Instruction block for calendar Discover (and any other Te Wiki AI plan). */
export function teWikiSwimAiPlanHint(): string {
  return [
    'For Te Wiki o te Reo Māori (and any te reo Māori campaign day), session_idea and coach_reminder MUST use swimming kupu with tohutō and a short English gloss — not greetings alone.',
    `Swim kupu: ${formatKupuWithGloss(TE_WIKI_SWIM_KUPU)}.`,
    'Name at least one set in te reo (e.g. kikī, kume, ruku, omaoma ki te pito). Keep kia ora / kia kaha / ka rawe as deck greetings.',
  ].join(' ');
}
